import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "components/button";
import Input from "components/input";
import { SelectBox } from "components/uikit-adapter";
import Dialog from "material-ui/Dialog";
import PropTypes from "prop-types";
import { Component } from "react";
import { Col, Row } from "react-flexbox-grid";
import intl from "react-intl-universal";
import { PriorityFormContainer } from "./styledPriorityForm";

class PriorityForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLoading: false,
    };
  }

  onSend = async () => {
    this.setState({ showLoading: true });
    try {
      await this.props.handleSend();
    } finally {
      this.setState({ showLoading: false });
    }
  };

  render() {
    const {
      open,
      systemPlanning,
      systemPlanningTypes,
      shipmentPriority,
      shipmentPriorityTypes,
      isShipmentPriorityEnabled,
      isSequentialPriorityEnabled,
      currentSequentialPriorityRound,
    } = this.props;

    return (
      <div>
        <Dialog
          title={intl.get("transports.otimizationCharge.actions.chooseOtimizationPriority")}
          contentStyle={{ width: "600px" }}
          open={open}
          autoScrollBodyContent
        >
          <PriorityFormContainer>
            <div className="priority-form-content">
              <Row className="priority-form-row">
                <Col xs={12} lg={12} md={12}>
                  <SelectBox
                    required
                    label={intl.get("transports.otimizationCharge.actions.otimizationFlow")}
                    name="systemPlanning"
                    value={systemPlanning}
                    valueKey="Key"
                    labelKey="Value"
                    onChange={(value) => this.props.changeValue("systemPlanning", value.Key)}
                    openOnFocus={true}
                    options={systemPlanningTypes}
                    width="100%"
                    styles={{}}
                  />
                </Col>
              </Row>
              <Row className="priority-form-row" style={{ height: "100px" }}>
                <Col xs={12} lg={12} md={12}>
                  {isSequentialPriorityEnabled ? (
                    <Input
                      name="shipmentPriority"
                      label={intl.get(
                        "transports.otimizationCharge.actions.sequentialPriorityRound"
                      )}
                      value={`P${currentSequentialPriorityRound}`}
                      readOnly
                      disabled
                    />
                  ) : (
                    <SelectBox
                      required
                      label={intl.get("transports.otimizationCharge.actions.programmationPriority")}
                      name="shipmentPriority"
                      value={shipmentPriority}
                      valueKey="Key"
                      labelKey="Value"
                      openOnFocus={true}
                      options={shipmentPriorityTypes}
                      onChange={(value) => this.props.changeValue("shipmentPriority", value.Key)}
                      width="100%"
                      disabled={!isShipmentPriorityEnabled}
                      styles={{}}
                    />
                  )}
                </Col>
              </Row>
              <div className="footer-dialog-buttons">
                <div className="line-buttons">
                  <Button
                    buttonType="default"
                    value={intl.get("geral.buttonsDefault.cancel")}
                    onClick={() => this.props.handleClose(false)}
                    className="button-priority-tms-form"
                    disabled={this.state.showLoading}
                  />
                  <div className="send-button-wrapper">
                    <Button
                      buttonType="primary"
                      value={intl.get("geral.buttonsDefault.send")}
                      className="button-priority-tms-form"
                      onClick={this.onSend}
                      disabled={this.state.showLoading}
                    />
                    {this.state.showLoading && (
                      <CircularProgress size={16} thickness={5} className="send-button-spinner" />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </PriorityFormContainer>
        </Dialog>
      </div>
    );
  }
}

PriorityForm.propTypes = {
  open: PropTypes.bool.isRequired,
  systemPlanning: PropTypes.number.isRequired,
  systemPlanningTypes: PropTypes.array.isRequired,
  shipmentPriority: PropTypes.number.isRequired,
  shipmentPriorityTypes: PropTypes.array.isRequired,
  isShipmentPriorityEnabled: PropTypes.bool,
  isSequentialPriorityEnabled: PropTypes.bool,
  currentSequentialPriorityRound: PropTypes.number,
  changeValue: PropTypes.func.isRequired,
  handleSend: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default PriorityForm;
